import type {
  ConfirmUploadParams,
  ConfirmUploadResponse,
  CreatePreRechargeConfigParams,
  PreRechargeConfigItem,
  PreRechargeConfigQueryParams,
  QueryUploadPreviewListParams,
  UpdatePreRechargeConfigParams,
  UploadPreRechargeConfigPreviewParams,
  UploadPreRechargeConfigPreviewResponse,
} from './type'

import type { PagingRequest } from '#/api/type'

import { requestClient } from '#/api'
import { defineApi } from '#/api/define-api'

export const preRechargeConfigApi = defineApi(
  'operation/custPreRechargeConfig',
  ({ prefix }) => {
    function queryPreRechargeConfig(
      params: PagingRequest<PreRechargeConfigQueryParams>,
    ) {
      return requestClient
        .post(prefix('query'), {
          condition: {
            customerId: params.condition?.customerId,
            customerName: params.condition?.customerName,
          },
          pageIndex: params.pageIndex,
          pageSize: params.pageSize,
        })
        .then((res) => {
          return {
            // items: [
            //   {
            //     id: 1,
            //     customerId: 1001,
            //     customerName: '测试商户A',
            //     historicalRecharge: 500_000,
            //     historicalSpend: 380_000,
            //     totalProfit: 120_000,
            //     profitCutoffDate: '2024-01-15',
            //     preRechargeRatio: 50,
            //     preRechargeLimit: 250_000,
            //     enabled: 1,
            //     updatedBy: '张三',
            //     updatedTime: '2024-01-20 10:30:00',
            //   },
            //   {
            //     id: 2,
            //     customerId: 1002,
            //     customerName: '测试商户B',
            //     historicalRecharge: 800_000,
            //     historicalSpend: 600_000,
            //     totalProfit: 200_000,
            //     profitCutoffDate: '2024-01-20',
            //     preRechargeRatio: 75,
            //     preRechargeLimit: 600_000,
            //     enabled: 1,
            //     updatedBy: '李四',
            //     updatedTime: '2024-01-21 14:20:00',
            //   },
            //   {
            //     id: 3,
            //     customerId: 1003,
            //     customerName: '测试商户C',
            //     historicalRecharge: 300_000,
            //     historicalSpend: 250_000,
            //     totalProfit: 50_000,
            //     profitCutoffDate: '2024-01-18',
            //     preRechargeRatio: 30,
            //     preRechargeLimit: 90_000,
            //     enabled: 2,
            //     updatedBy: '王五',
            //     updatedTime: '2024-01-19 09:15:00',
            //   },
            //   {
            //     id: 4,
            //     customerId: 1004,
            //     customerName: '测试商户D',
            //     historicalRecharge: 1_200_000,
            //     historicalSpend: 950_000,
            //     totalProfit: 250_000,
            //     profitCutoffDate: '2024-01-22',
            //     preRechargeRatio: 60,
            //     preRechargeLimit: 720_000,
            //     enabled: 1,
            //     updatedBy: '赵六',
            //     updatedTime: '2024-01-23 16:45:00',
            //   },
            //   {
            //     id: 5,
            //     customerId: 1005,
            //     customerName: '测试商户E',
            //     historicalRecharge: 450_000,
            //     historicalSpend: 400_000,
            //     totalProfit: 50_000,
            //     profitCutoffDate: '2024-01-16',
            //     preRechargeRatio: 25,
            //     preRechargeLimit: 112_500,
            //     enabled: 1,
            //     updatedBy: '孙七',
            //     updatedTime: '2024-01-17 11:30:00',
            //   },
            // ].map((item) => ({
            //   ...item,
            //   enabled: String(item.enabled),
            // })),
            items:
              res?.list.map((item: PreRechargeConfigItem) => ({
                id: item.id,
                customerId: item.customerId,
                customerName: item.customerName,
                historicalRecharge: item.historicalRecharge,
                historicalSpend: item.historicalSpend,
                totalProfit: item.totalProfit,
                profitCutoffDate: item.profitCutoffDate,
                preRechargeRatio: item.preRechargeRatio,
                preRechargeLimit: item.preRechargeLimit,
                preRechargeAvailable: item.preRechargeAvailable,
                enabled: String(item.enabled),
                updatedBy: item.updatedBy,
                updatedTime: item.updatedTime,
              })) || [],
            total: res?.total || 0,
          }
        })
    }

    function listCustomerPreRechargeStatus() {
      return requestClient.get(prefix('allCustPreRecharge')).then((res) => {
        const list = Array.isArray(res) ? res : res?.list || []
        return list.map((item: any) => ({
          label:
            item.customerName ??
            item.nickname ??
            String(item.customerId ?? item.userId ?? ''),
          code: item.userId ? String(item.userId) : undefined,
          value: String(item.customerId ?? item.userId ?? ''),
          customerId: item.customerId,
          customerName: item.customerName,
          hasPreRecharge: item.hasPreRecharge,
        }))
      })
    }

    function downloadTemplate() {
      return requestClient.get(prefix('downloadTemplate')).then((res) => {
        return res?.url
      })
    }

    function createPreRechargeConfig(params: CreatePreRechargeConfigParams) {
      return requestClient.post(prefix('create'), {
        customerId: params.customerId,
        historicalRecharge: params.historicalRecharge,
        historicalSpend: params.historicalSpend,
        totalProfit: params.totalProfit,
        profitCutoffDate: params.profitCutoffDate,
        preRechargeLimit: params.preRechargeLimit,
        enabled: Number(params.enabled),
      })
    }

    function updatePreRechargeConfig(params: UpdatePreRechargeConfigParams) {
      return requestClient.post(prefix('update'), {
        id: params.id,
        customerId: params.customerId,
        historicalRecharge: params.historicalRecharge,
        historicalSpend: params.historicalSpend,
        totalProfit: params.totalProfit,
        profitCutoffDate: params.profitCutoffDate,
        preRechargeLimit: params.preRechargeLimit,
        enabled: Number(params.enabled),
      })
    }

    /**
     * 上传预充配置预览
     * POST /gobestads/operation/adsCustomerPreRechargeConfig/uploadPreview
     */
    function uploadPreRechargeConfigPreview(
      params: UploadPreRechargeConfigPreviewParams,
    ) {
      const formData = new FormData()
      formData.append('file', params.file)

      return requestClient
        .post<UploadPreRechargeConfigPreviewResponse>(
          prefix('uploadPreview'),
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } },
        )
        .then((res) => {
          return {
            totalCount: res?.totalCount || 0,
            validCount: res?.validCount || 0,
            uploadId: res?.uploadId || '',
          }
        })
    }

    /**
     * 查询上传预览列表
     * POST /gobestads/operation/adsCustomerPreRechargeConfig/queryUploadPreviewList
     */
    function queryUploadPreviewList(params: QueryUploadPreviewListParams) {
      return requestClient
        .post(prefix('queryUploadPreviewList'), {
          condition: {
            uploadId: params.condition.uploadId,
          },
          pageIndex: params.pageIndex,
          pageSize: params.pageSize,
        })
        .then((res) => {
          return {
            list: res?.list || [],
            total: res?.total,
            pageIndex: res?.pageIndex,
            pageSize: res?.pageSize,
          }
        })
    }

    /**
     * 确认上传预充配置
     * POST /gobestads/operation/adsCustomerPreRechargeConfig/confirmUpload
     */
    function confirmUpload(params: ConfirmUploadParams) {
      return requestClient
        .post<ConfirmUploadResponse>(prefix('confirmUpload'), {
          uploadId: params.uploadId,
        })
        .then((res) => {
          return {
            successCount: res?.successCount || 0,
            totalCount: res?.totalCount || 0,
          }
        })
    }

    return {
      queryPreRechargeConfig,
      downloadTemplate,
      createPreRechargeConfig,
      updatePreRechargeConfig,
      listCustomerPreRechargeStatus,
      uploadPreRechargeConfigPreview,
      queryUploadPreviewList,
      confirmUpload,
    }
  },
)
